module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/0a661ae903f80ff687c29013d0b21d81.svg";


//////////////////
// WEBPACK FOOTER
// ./components/certificates/components/rank-dropdown/assets/dropdownDown.svg
// module id = ruIP
// module chunks = 1